import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { formatPrice } from '@/utils/formatters.ts';
import HeadlineNumber from '@/components/ui/HeadlineNumber.tsx';
import { formatShare } from '@/features/dashboard/tours/types/share.utils.ts';
import { cn } from '@/lib/utils.ts';

interface BreakdownHeadlineProps {
  value: MoneyValueDto;
  total: MoneyValueDto;
  /** Wynik, którego jeszcze nie ma — wielka czarna zerówka czyta się jak fakt. */
  dimmed?: boolean;
}

/** Wielka liczba karty walutowej: ile z ilu i jaka to część całości. */
const BreakdownHeadline = ({
  value,
  total,
  dimmed = false,
}: BreakdownHeadlineProps) => (
  <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
    <HeadlineNumber dimmed={dimmed}>
      {formatPrice(value.amount, value.currency)}
    </HeadlineNumber>
    <span className="text-[13px] text-neutral-500">
      z {formatPrice(total.amount, total.currency)}
    </span>
    <span className="ml-auto text-[13px] font-semibold tabular-nums text-neutral-500">
      {formatShare(value.amount, total.amount)}
    </span>
  </div>
);

export default BreakdownHeadline;
